import {
  ActivityItem,
  ComboBox,
  Icon,
  IconButton,
  Label,
  Link,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import { FunctionComponent } from "react";
import {
  IconButtonStyles,
  addIcon,
  emojiIcon,
  hostStyles,
} from "../../../utils/helpers/stylesHelper";

interface EquipoEvaluadorVistaProps {
  plantillaId: string;
}
const classNames = mergeStyleSets({
  exampleRoot: {
    marginTop: "20px",
  },
  nameText: {
    fontWeight: "bold",
  },
});
// York, Dueñas Boada - Sub Gerente de Tecnología de Información
// Carol Isaura, Gonzales Pérez - Asistente de Planeamiento y Control de TI
// John Ilichs Castillo Yupanqui - Coordinador de Network
// Emerson Flores Grandez - Jefe de Infraestructura de TI
// Oscar, Milla Lliuya - Ingeniero de seguridad
// Herodian, Hancco Araujo  - Representante de los trabajadores
// Wilmer Nicanor, Avellaneda Andrade - ISEM
const activityItemExamples = [
  {
    key: 1,
    activityDescription: [
      <Link key={1} className={classNames.nameText}>
        York Dueñas Boada
      </Link>,
    ],
    activityIcon: <Icon iconName={"ReminderPerson"} />,
    comments: [
      <span key={1}>Puesto : </span>,
      <Link key={2} className={classNames.nameText}>
        Sub Gerente de Tecnología de Información
      </Link>,
    ],
    timeStamp: "Evaluador 1",
  },
  {
    key: 2,
    activityDescription: [
      <Link key={1} className={classNames.nameText}>
        Carol Isaura Gonzales Pérez
      </Link>,
    ],
    activityIcon: <Icon iconName={"ReminderPerson"} />,
    comments: [
      <span key={1}>Puesto : </span>,
      <Link key={2} className={classNames.nameText}>
        Asistente de Planeamiento y Control de TI
      </Link>,
    ],
    timeStamp: "Evaluador 2",
  },
  {
    key: 3,
    activityDescription: [
      <Link key={1} className={classNames.nameText}>
        John Ilichs Castillo Yupanqui
      </Link>,
    ],
    activityIcon: <Icon iconName={"ReminderPerson"} />,
    comments: [
      <span key={1}>Puesto : </span>,
      <Link key={2} className={classNames.nameText}>
        Coordinador de Network
      </Link>,
    ],
    timeStamp: "Evaluador 3",
  },
  {
    key: 4,
    activityDescription: [
      <Link key={1} className={classNames.nameText}>
        Emerson Flores Grandez
      </Link>,
    ],
    activityIcon: <Icon iconName={"ReminderPerson"} />,
    comments: [
      <span key={1}>Puesto : </span>,
      <Link key={2} className={classNames.nameText}>
        Jefe de Infraestructura de TI
      </Link>,
    ],
    timeStamp: "Evaluador 4",
  },
  {
    key: 5,
    activityDescription: [
      <Link key={1} className={classNames.nameText}>
        Oscar Milla Lliuya
      </Link>,
    ],
    activityIcon: <Icon iconName={"ReminderPerson"} />,
    comments: [
      <span key={1}>Puesto : </span>,
      <Link key={2} className={classNames.nameText}>
        Ingeniero de seguridad
      </Link>,
    ],
    timeStamp: "Evaluador 5",
  },
];

const flexContainerStyle = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "center",
  alignContent: "stretch",
  alignItems: "center",
};

const flexItemStyle1 = {
  order: 0,
  flex: "1 1 auto",
  alignSelf: "auto",
};

const flexItemStyle2 = {
  order: 0,
  flex: "0 1 auto",
  alignSelf: "center",
};

const EquipoEvaluadorVista: FunctionComponent<
  EquipoEvaluadorVistaProps
> = () => {
  return (
    <>
    <br />
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-depth-8 ms-fontColor-themePrimary--hover">
        <Label>Agregar Evaluador</Label>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignContent: "stretch",
            alignItems: "center",
          }}
        >
          <div
            style={{
              order: 0,
              flex: "1 1 auto",
              alignSelf: "auto",
              paddingRight: 20,
            }}
          >
            <ComboBox
              defaultSelectedKey="C"
              // label="Personas"
              options={[
                { key: "A", text: "78878945 | Wilmer Nicanor" },
                { key: "b", text: "78867347 | Herodian, Hancco Araujo " },
              ]}
              useComboBoxAsMenuWidth
              //   styles={comboBoxStyles}
              //   calloutProps={{ doNotLayer: true }}
            />
          </div>
          <div
            style={{
              order: 0,
              flex: "0 1 auto",
              alignSelf: "center",
            }}
          >
            <div>
              <TooltipHost
                content="Agregar Evaluador"
                id="tooltip"
                styles={hostStyles}
              >
                <IconButton
                  iconProps={addIcon}
                  aria-label="Emoji"
                  // disabled={props.disabled}
                  // checked={props.checked}
                  styles={IconButtonStyles}
                  // onClick={openAsignacion}
                />
              </TooltipHost>
            </div>
          </div>
        </div>
        <br />
      </div>
      <br />
      <div>
        {activityItemExamples.map((item: { key: string | number }) => (
          <>
            <br />
            <ActivityItem
              {...item}
              key={item.key}
              // className={classNames.exampleRoot}
            />
          </>
        ))}
      </div>
    </>
  );
};

export default EquipoEvaluadorVista;
